module.exports = __webpack_public_path__ + "static/media/ic_blueprint.ffe67227.svg";